import { Menu, MenuWrapper } from "../interfaces/menu.interface";

export class MenuWrapperImpl implements MenuWrapper {
    Workaround = "";
    Menu: Menu[];

    constructor(menus: Menu[]) {
        this.Menu = menus;
    }
}

export class MenuImpl implements Menu {
    constructor(
        public Name: string,
        public Href: string,
        public Classes: string,
        public Icon: string,
        public Badge: string,
        public BadgeText: string,
        public Claim: string,
        public Order: string,
        public IsPublic: boolean,
        public SubMenu: Menu[]
    ) {}
}